import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import account from "../../../services/accountService";
import { setSignupData } from "../../../redux/signup";
import EditLocation from "../../../components/EditLocation";
import { LocationAutocompleteType } from "../../../typings/google";
import { GAEventNames, GACategoryName, GAUniqueEventIds } from "../../../helpers/Enums";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";

export type CitySuggestion = {
    id: number;
    cityName: string;
}

const LoactionQuestion = (props: any) => {
    const dispatch = useDispatch();
    const register = useSelector((state: RootState) => state.signup);
    const question = useSelector((state: RootState) => state.signupQuestions.questions?.filter(x => x.questionId === 7));


    const onSave = (selectedLocation: CitySuggestion) => {
        register.cityId = selectedLocation.id;
        dispatch(setSignupData(register));
        props.next();

        recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 8", "אישור מיקום", GAUniqueEventIds.APP_SIGNUP)


    }

    return (
        <>
            <EditLocation
                buttonText={"אפשר להמשיך"}
                subtitle={question && question[0].questionSubTitle}
                title={question && question[0].question}
                value={undefined} onSave={onSave} />

        </>
    )
}

export default LoactionQuestion;
